module.exports = __webpack_public_path__ + "img/country.34cb12d1.png";